export default __webpack_public_path__ + "static/media/pic1.70d2f989.jpg";